export default __webpack_public_path__ + "static/media/MSSolution-innovation.8f572057.svg";